import { styled } from "styled-components";

export const OrderDetailDialogContainer = styled.div`
display: flex;
flex-direction: column;
gap: 30px;
padding: 10px;
`
export const OrderDetailDialogHeaderContainer = styled.div`
display: flex;
flex-direction: column;
gap: 5px;
position: relative;
`
export const OrderDetailRow = styled.div`
display: flex;
align-items: center;
gap: 20px;
`
export const OrderDetailRowLabel = styled.div`
`
export const OrderDetailRowData = styled.div`
opacity: 0.5;
display: flex;
align-items: center;
`
export const OrderDetailDialogBodyContainer = styled.div`
display: flex;
align-items: center;
gap: 60px;
`
export const DeliveryAddressContainer = styled.div`
display: flex;
flex-direction: column;
gap: 10px;
`
export const DeliveryAddressTitle = styled.div`
font-weight: bold;
`
export const DeliveryAddress = styled.div`
width: 250px;
opacity: 0.5;
`
export const CustomerContainer = styled.div`
display: flex;
flex-direction: column;
gap: 10px;
`
export const CustomerTitle = styled.div`
font-weight: bold;
`
export const CustomerWrapper = styled.div`
`
export const OrderDetailDialogBodyWrapper = styled.div`
display: flex;
flex-direction: column;
gap: 30px;
`
export const PaymentStatus = styled.div`
padding: 5px 15px 5px 15px;
border-radius: 7px;
/* background-color: green; */
border: 1px solid green;
color: green;
position: absolute;
right: 0px;
top: 0px;
`
export const ProductImage = styled.img`
height: 40px;
width: 40px;
border-radius: 7px;
cursor: pointer;
`

export const PackingImage = styled.img`
height: 100px;
width: 100px;
border-radius: 7px;
`
export const ProductName = styled.div`
`
export const TrackingDetailTitleContainer = styled.div`
display: flex;
align-items: center;
gap: 10px;
background-color: #1876d1;
width: fit-content;
border-radius: 7px;
padding: 10px;
cursor: pointer;
`
export const TrackingDetailTitle = styled.div`
color: #ffffff;
`
export const TrackingDetailContainer = styled.div`
display: flex;
flex-direction: column;
gap: 10px;
background: #0b3157;
padding: 10px;
border-radius: 7px;
`
export const TrackingDetailRow = styled.div`
display: flex;
flex-direction: column;
gap: 5px;
`
export const TrackingDetailLabel = styled.div`
color: #ffffff;
`
export const TrackingDetailData = styled.div`
opacity: 0.5;
color: #ffffff;
`
export const PackingVideo = styled.video`
width: 200px;
height: 100px;
border-Radius: 7px;
background: #ffffff;
`
export const TrackingWrapper = styled.div`
display: flex;
flex-direction: column;
gap: 5px;
`